import React, { useEffect } from "react";
import LogoComponent from "./components/LogoComponent";
import { Col, Row } from "antd";
import Menu from "./components/Menu";
// import { ReactComponent as MenuIcon } from "../../assets/images/icon/barIcon.svg";
// import { ReactComponent as CloseIcon } from "../../assets/images/icon/close.svg";
// import ResponsiveMenu from "./components/ResponsiveMenu";

const HeaderPage: React.FC<any> = () => {
    // const [click, setClick] = useState(false);
    // const [isOpen, setIsOpen] = useState(false);
    // const handleClick = () => {
    //     setClick(!click);
    //     setIsOpen(!isOpen);
    // };
    // const close = () => {
    //     setIsOpen(false);
    //     setClick(false);
    useEffect(() => {
		window.addEventListener("scroll", isSticky);
		return () => {
			window.removeEventListener("scroll", isSticky);
		};
	});

	const isSticky = () => {
		const header = document.querySelector(".main__page__header");
		const scrollTop = window.scrollY;
		scrollTop >= 100
			? header?.classList.add("isSticky")
			: header?.classList.remove("isSticky");
	};
    // };
    return (
        <>
            <header className="main__page__header">
                <div className="headerContainer">
                    <Row>
                        <div className="headerWrap">
                            <Col span={6}>
                                <LogoComponent />
                            </Col>
                            <Col span={18}>
                                <Menu />
                            </Col>
                        </div>
                        {/* <div className="menuToggle" onClick={handleClick}>
                            {!click ? <MenuIcon /> : <CloseIcon className="closeIcon"/>}
                        </div>
                        <ResponsiveMenu closeDrawer={close} open={isOpen} /> */}
                    </Row>


                </div>

            </header>
        </>
    );
};

export default HeaderPage;
